import angular from 'angular';
import BatchService from './batch.service';

let batchModule = angular.module('batch', []).service('batchService', BatchService);

export default batchModule;



// WEBPACK FOOTER //
// ./app/common/batch/batch.js